<template>
  <div class="page-wrapper">
    <div style="width: 100%; height: 50px;">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 text-left" style="height: 50px; line-height: 50px;">
            <date-picker v-model="dateRange" valueType="format" @change="dateRangeSelected" range></date-picker>

            <select v-model="selectedCustomerId" style="height: 34px; line-height: 34px;">
              <option value="0">All Customers</option>
              <option v-for="c in customers" :value="c.id">{{c.title}}</option>
            </select>

            <button class="btn btn-success" @click="getInvoiceList">불러오기</button>
            <button class="btn btn-danger" @click="getPendingInvoiceList">미완료 불러오기</button>

            <button class="btn btn-primary" @click="getStatement">PDF Statement</button>

          </div>
        </div>
      </div>
    </div>
    <div style="width: 100%; height: calc(100% - 50px); overflow-y: auto;">
      <div class="container-fluid" v-if="statement !== false">
        <div class="row">
          <div class="col-6 text-left">
            <strong>TO:</strong> {{statement.recipient}}
            <br/>
            {{statement.address}}
          </div>
          <div class="col-6 text-right">
            <strong>Period:</strong> {{statement.period}}
          </div>
        </div>
        <div class="row" style="margin-top:20px;">
          <div class="col-12">
            <table class="table">
              <tr>
                <th style="width: 150px;">IVC Date</th>
                <th style="width: 150px;">Due</th>
                <th>INV No</th>
                <th class="text-left">청구처</th>
                <th class="text-left">Shipper</th>
                <th class="text-left">BL No.</th>
                <th>S/ Mode</th>
                <th>Vol</th>
                <th>Debit</th>
                <th>Credit</th>
                <th>Balance</th>
                <th></th>
              </tr>
              <tbody>
              <tr v-for="invoice in statement.invoices" v-bind:class="[{'dist-row': invoice.finalised === false},{'completed-request-row': invoice.finalised === true}]">
                <td>{{invoice.invoiceDate}}</td>
                <td><span v-if="invoice.finalised === false">{{invoice.dueDate}}</span><span v-else>완료</span></td>
                <td>{{invoice.invoiceNumber}}</td>
                <td class="text-left">{{getCustomerTitle(invoice.customerId)}}</td>
                <td class="text-left">{{invoice.shipper}}</td>
                <td class="text-left">{{invoice.blNo}}</td>
                <td>{{invoice.shippingMode}}</td>
                <td>{{invoice.volume}}</td>
                <td class="text-right">
                  <span v-if="invoice.type === 'invoice'">{{(invoice.total/100.0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span><span v-else>0.00</span>
                </td>
                <td class="text-right">
                  <span v-if="invoice.type === 'credit'">-{{(invoice.total/100.0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span><span v-else>0.00</span>
                </td>
                <td class="text-right">
                  <span v-if="invoice.type === 'credit'">-</span>{{((invoice.total)/100.0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                </td>
                <th><button class="btn btn-success" @click="openInvoice(invoice.id)"><i class="fas fa-edit"></i></button></th>
              </tr>

              </tbody>
              <tr>
                <th colspan="8">
                  GRAND TOTAL (GBP)
                </th>
                <th>{{(statement.debit/100.0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</th>
                <th>{{(statement.credit/100.0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</th>
                <th>{{(statement.balance/100.0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</th>
                <th/>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <template v-if="pdfItem !== false">
      <transition name="slideup">
        <pdf-viewer
          :item="pdfItem"
          :on-close="closePdfViewer">

        </pdf-viewer>
      </transition>
    </template>
    <div style="position: fixed; top:0; left: 0; width: 100%; height: 100%; background-color: rgba(0,0,0,0.6);" v-if="invoiceItem != false" @click="invoiceItem = false">
      <div style="position: absolute; top:50%; left: 50%; width: calc(100% - 20px); max-width: 1500px; height: 90%; transform: translate(-50%, -50%); background-color: white;" v-on:click.stop="dummy">

        <InvoiceView v-if="invoiceItem !== false"
                     :item="invoiceItem"
                     :customers="customers"
                     :on-updated="onInvoiceItemUpdated"
                     :on-close="onInvoiceItemClosed"
                     :on-deleted="onInvoiceItemDeleted"/>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import {getCustomers} from "../api/customers";
import {generateOrderNumber, millisToDate, showDialog} from "../api/utils";
import {getInvoice, getInvoiceQuery, getStatementPDF} from "../api/invoices";
import FileDownload from "js-file-download";
import InvoiceView from "./InvoiceView";
import PdfViewer from "./PdfViewer";
export default {
  name: "Sales",
  data() {
    return {
      statement: false,
      selectedCustomerId:0,
      customers:[],
      items:[],
      dateRange:null,
      invoiceItem: false,
      pdfItem: false,
    }
  },
  components: {
    DatePicker,
    InvoiceView,
    PdfViewer
  },
  created() {
  },
  mounted() {
    this.getCustomers();
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    dummy: function() {

    },
    dateRangeSelected: function() {
      console.log("dateRangeSelected")
      console.log(this.$data.dateRange)

      if(this.$data.dateRange.length !== 2) {
        return;
      }

      if(this.$data.dateRange[0] > this.$data.dateRange[1]) {
        let temp = this.$data.dateRange[1];
        this.$data.dateRange[0] = this.$data.dateRange[1];
        this.$data.dateRange[1] = temp;
      }

    },
    getCustomerTitle: function(id) {
      if(this.$data.customers === null || this.$data.customers.length === 0) {
        return 'Unknown';
      }
      for(let i = 0 ; i < this.$data.customers.length ; i++) {
        if(this.$data.customers[i].id === id) {
          return this.$data.customers[i].title;
        }
      }

      return 'Unknown';
    },
    getCustomers: function() {
      let self = this;
      getCustomers()
      .then(function(data) {
        if(data.success === true) {
          self.$data.customers = data.item;
        } else {
          showDialog(data.message);

        }
      })
      .catch(function(err) {

      })
    },
    updateInvoice: function(index) {
      // updateInvoice()
    },
    getPendingInvoiceList: function() {
      if(this.$data.dateRange === null || this.$data.dateRange.length !== 2) {
        showDialog("Select Dates");
        return;
      }
      let query = "dateFrom="+this.$data.dateRange[0] + '&dateTo=' + this.$data.dateRange[1];
      if(this.$data.selectedCustomerId > 0) {
        query += '&customerId='+this.$data.selectedCustomerId;
      }

      query += '&pending=true';

      let self = this;
      getInvoiceQuery(query)
        .then(function(data) {
          if(data.success) {
            console.log(data.item);
            self.generateReport(data.item);
          } else {
            showDialog(data.message);
          }
        })
        .catch(function(err) {
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ')';
          }
          showDialog(msg, "ERROR");
        })
    },
    getInvoiceList: function() {
      if(this.$data.dateRange === null || this.$data.dateRange.length !== 2) {
        showDialog("Select Dates");
        return;
      }
      let query = "dateFrom="+this.$data.dateRange[0] + '&dateTo=' + this.$data.dateRange[1];
      if(this.$data.selectedCustomerId > 0) {
        query += '&customerId='+this.$data.selectedCustomerId;
      }

      let self = this;
      getInvoiceQuery(query)
      .then(function(data) {
        if(data.success) {
          console.log(data.item);
          self.generateReport(data.item);
        } else {
          showDialog(data.message);
        }
      })
      .catch(function(err) {
        let msg = err;
        if(err.response !== undefined) {
          msg += ' (' + err.response + ')';
        }
        showDialog(msg, "ERROR");
      })
    },
    getStatement: function() {
      let self = this;
      getStatementPDF(this.$data.statement)
      .then(function(data) {
        if(data.success === true) {
          if(data.item.url !== undefined && data.item.url !== null && data.item.url.length > 0) {
            self.$data.statement.url = data.item.url;
            let emailTo = '';
            if(self.$data.selectedCustomerId > 0) {
              for(let i = 0 ; i < self.$data.customers.length ; i++){
                if(self.$data.customers[i].id === self.$data.selectedCustomerId) {
                  emailTo = self.$data.customers[i].email;
                }
              }
            }
            let emailForm = {
              to: emailTo,
              subject:'Statement ' + millisToDate(new Date(), '-'),
              body: '안녕하세요 UKO Shipping입니다.\n',

              documents:[{
                title:'Statement-' + self.$data.statement.period,
                url:self.$data.statement.url,
              }]
            }
            self.$data.pdfItem = {
              title: 'Statement',
              emailForm: emailForm,
              url:self.$data.statement.url,
            }
          }
        }




        // FileDownload(response.data, self.$data.statement.recipient.toUpperCase() + '-' + self.$data.statement.period + ".pdf");
      })
      .catch(function(err) {

        console.log(err);
        if(err.response !== undefined) {
          console.log(err.response);
        }
      })
    },
    generateReport: function(list) {
      let statement = {
        recipient:'All',
        address:'',
        period:this.$data.dateRange[0] + ' - ' + this.$data.dateRange[1],
        amount:0,
        vat:0,
        total:0,
        credit:0,
        debit:0,
        balance:0,
        invoices:list,
      };
      for(let i = 0 ; i < this.$data.customers.length ; i++) {
        if(this.$data.customers[i].id === this.$data.selectedCustomerId) {
          statement.recipient = this.$data.customers[i].title;
          statement.address = this.$data.customers[i].address;
          break;
        }
      }

      for(let i = 0 ; i < list.length ; i++) {
        if(list[i].type === 'invoice') {
          statement.amount += list[i].amount;
          statement.vat += list[i].vat;
          statement.total += list[i].total;
          statement.debit += list[i].total;
          statement.balance += list[i].total;
        } else if(list[i].type === 'credit') {
          statement.amount -= list[i].amount;
          statement.vat -= list[i].vat;
          statement.total -= list[i].total;
          statement.credit -= list[i].total;
          statement.balance -= list[i].total;
        }
      }
      // statement.balance = statement.debit - statement.credit;

      this.$data.statement = statement;

    },

    updateReport: function() {
      for(let i = 0 ; i < this.$data.statement.invoices.length ; i++) {
        this.$data.statement.debit += this.$data.statement.invoices[i].total;
        this.$data.statement.credit += this.$data.statement.invoices[i].paid;
      }
      this.$data.statement.balance = this.$data.statement.debit - this.$data.statement.credit;

    },

    openInvoice: function(id) {
      let self = this;
      getInvoice(id)
      .then(function(data) {
        if(data.success === true) {
          self.$data.invoiceItem = data.item;

        } else {
          showDialog(data.message);
        }
      })
      .catch(function(err) {
        let msg = err;
        if(err.response !== undefined) {
          msg += ' (' + err.response +')';
        }
        showDialog(msg, "ERROR");
      })
    },
    onInvoiceItemUpdated: function(item) {
      let found = false;


      if(found === false) {
        for (let i = 0; i < this.$data.statement.invoices.length; i++) {
          if (this.$data.statement.invoices[i].id === item.id) {
            this.$data.statement.invoices.splice(i, 1, item);
            found = true;
            break;
          }
        }
      }

      this.$data.invoiceItem = false;
      this.updateReport();
    },
    onInvoiceItemClosed: function() {
      this.$data.invoiceItem = false;
    },
    onInvoiceItemDeleted: function(item) {
      for (let i = 0; i < this.$data.statement.invoices.length; i++) {
        if (this.$data.statement.invoices[i].id === item.id) {
          this.$data.statement.invoices.splice(i, 1);
          break;
        }
      }

      this.$data.invoiceItem = false;
      this.updateReport();
    },
    closePdfViewer: function() {
      this.$data.pdfItem = false;
    }
  },

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Sales.vue